module.exports = __webpack_public_path__ + "static/media/rci_at_sea_sunset_lounge.153588ab.jpg";